import { useState } from 'react';
import { TagPill } from './TagPill';
import { ProjectModal } from './ProjectModal';
import type { Project } from '../types';
import './project-cards.css';

export function ProjectCard({ project }: { project: Project }) {
  const [mode, setMode] = useState<'details' | 'demo' | null>(null);
  const repository = project.github_url || project.content?.source_url;
  return <><article className="project-card uniform-project-card">
    <div className="project-image" aria-hidden="true">{project.cover_image_url ? <img src={project.cover_image_url} alt="" loading="lazy" /> : <span>&gt;_</span>}</div>
    <div className="project-copy"><div className="post-tags">{(project.tags ?? []).slice(0,4).map(tag => <TagPill key={tag.slug} tag={tag} />)}</div><h3 title={project.title}>{project.title}</h3>
      <p className="pc-summary">{project.summary}</p><button type="button" className="pc-more" aria-label={`More about ${project.title}`} onClick={() => setMode('details')}>More →</button>
      <div className="pc-actions" aria-label={`Actions for ${project.title}`}>
        <button type="button" onClick={() => setMode('details')} aria-haspopup="dialog">View details</button>
        <button type="button" disabled={!project.demo_url} title={project.demo_url ? undefined : 'Live demo unavailable'} onClick={() => setMode('demo')} aria-haspopup="dialog">Live demo</button>
        {repository ? <a href={repository} target="_blank" rel="noreferrer" aria-label={`Open repository for ${project.title}`}>Repository</a> : <span aria-disabled="true">Repository</span>}
      </div>
    </div></article>{mode ? <ProjectModal project={project} initialMode={mode} onClose={() => setMode(null)} /> : null}</>;
}
